var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteLogoSub = function SvgWhiteLogoSub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 43.999,
    viewBox: "0 0 167 43.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 19,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-920 -15.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_371",
    "data-name": "Symbol 371",
    transform: "translate(921 15.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M-256.59,260.443a1.813,1.813,0,0,1,1.122.491,1.1,1.1,0,0,1,.191,1,15.4,15.4,0,0,1-.561,1.49q-.281.772-.592,1.54c-.4,1.038-.822,2.068-1.209,3.109s-.741,2.068-1.105,3.1c-.721,2.048-1.2,4.164-1.717,6.265-.264,1.058-.561,2.107-.842,3.157s-.561,2.062-.932,3.053a3.318,3.318,0,0,1-1.709,2.017,2.22,2.22,0,0,1-1.246.065,1.366,1.366,0,0,1-.954-.78q-1.574-2.82-2.859-5.777c-.861-1.972-1.714-3.973-2.525-5.979q-.306-.76-.609-1.523a9.665,9.665,0,0,1-.693-3.019,2.012,2.012,0,0,1,1.33-1.493,2.127,2.127,0,0,1,1.978.37,4.484,4.484,0,0,1,.421.6c.132.216.281.429.4.648a13.5,13.5,0,0,1,.668,1.364c.412.96.777,1.936,1.173,2.9q.631,1.538,1.277,3.072a11.593,11.593,0,0,0,.637,1.369,17.514,17.514,0,0,0,.525-1.832c.174-.665.348-1.33.53-1.989.362-1.313.758-2.615,1.17-3.914s.842-2.6,1.308-3.889a13.677,13.677,0,0,1,1.627-3.42,6.67,6.67,0,0,1,1.322-1.4,3.63,3.63,0,0,1,.794-.469,1.229,1.229,0,0,1,.471-.129h.606c.143.031-.239,0,0,0",
    transform: "translate(272.845 -260.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M-113.95,302.309c.842-1.122,2.085-3.112,1.813-3.392s-1.818.965-2.971,2.486-1.619,3.232-1.4,3.339,1.706-1.319,2.551-2.436m1.667,2.6a11.293,11.293,0,0,1-1.655,1.984,5.441,5.441,0,0,1-2.127,1.176,4.043,4.043,0,0,1-2.385.02,2.5,2.5,0,0,1-1.033-.721,2.98,2.98,0,0,1-.348-.519,3.764,3.764,0,0,0-.309-.561c-.146.18-.258.382-.4.561a3.4,3.4,0,0,1-.494.5,4.444,4.444,0,0,1-1.122.671,11.981,11.981,0,0,1-3.14.819,13.576,13.576,0,0,1-3.4-.022c-.561-.07-1.145-.149-1.712-.261a2.347,2.347,0,0,1-1.19-.48,2.357,2.357,0,0,1-.6-2.183,2.2,2.2,0,0,1,.643-1.083.87.87,0,0,1,.561-.312,2.058,2.058,0,0,1,.721.241,10.116,10.116,0,0,0,3.227.9c.561.025,2.416-.247,2.2-.561s-2.9-1.01-3.987-1.282a12.439,12.439,0,0,1-2.994-1.052,4.164,4.164,0,0,1-1.122-.808,1.88,1.88,0,0,1-.46-1.232,3.6,3.6,0,0,1,1.091-2.632,6.983,6.983,0,0,1,2.321-1.49,7.855,7.855,0,0,1,3.117-.662,3.265,3.265,0,0,1,1.566.306,1.75,1.75,0,0,1,.71,1.1c.123.373.412.915.1,1.265a1.035,1.035,0,0,1-.561.253c-.281.076-.586.126-.878.185l-1.7.334-.78.154c-.281.056-.943.14-.937.359s.937.6,1.193.707a10.1,10.1,0,0,0,1.532.483c1.094.281,2.189.561,3.266.9a5.609,5.609,0,0,1,2.525,1.265,3.617,3.617,0,0,1,.4.485,5.564,5.564,0,0,0,.345.513,12.318,12.318,0,0,1,.645-1.9,11.619,11.619,0,0,1,1.063-1.765,13.615,13.615,0,0,1,2.724-2.915,23.85,23.85,0,0,1,3.684-2.071c.317-.157.637-.309.948-.474a3.449,3.449,0,0,1,.9-.373,1.505,1.505,0,0,1,1.526.323,3.375,3.375,0,0,1,.6,1.639c.132.715.244,1.434.376,2.149a23,23,0,0,0,1.075,4.175,11.674,11.674,0,0,0,.881,1.883c.351.561.774,1.1,1.122,1.667a2.7,2.7,0,0,1,.477,1.782.974.974,0,0,1-.393.643,2.307,2.307,0,0,1-.926.393,2.271,2.271,0,0,1-1.813-.645,16.414,16.414,0,0,1-2.11-3.1c-.311-.659-1.094-2.873-1.38-2.9s-1.058,1.448-1.583,2.175",
    transform: "translate(172.549 -285.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M-218.415,298.561a2.052,2.052,0,0,0,.693-.4,1.858,1.858,0,0,0,.536-1.375,1,1,0,0,0-.263-.725,1,1,0,0,0-.7-.321,1.393,1.393,0,0,0-1.263,1.007,3.647,3.647,0,0,0,0,2.191c.379-.14.676-.25,1.013-.379m.1,3.8a2.828,2.828,0,0,0,.828.264,4.182,4.182,0,0,0,1.745-.02,5.514,5.514,0,0,0,1.616-.814,11.583,11.583,0,0,0,1.549-1.184c.5-.452,1.95-1.779,2.023-1.891a1.215,1.215,0,0,0,.118-.707c0-.679,0-1.361.028-2.04a1.521,1.521,0,0,1,.407-1.122,1.666,1.666,0,0,1,1.442-.224c.177.037.354.081.528.121a2.506,2.506,0,0,1,.943.687,12.075,12.075,0,0,0,1.044-1.425c.353-.5.727-.988,1.122-1.453a3.511,3.511,0,0,1,1.178-1.013,2.584,2.584,0,0,1,1.4-.171,1.24,1.24,0,0,1,1,.648c.126.253,2.363,10.255,2.464,10.875s.244,1.2.393,1.8a1.6,1.6,0,0,1-.115,1.538,1.8,1.8,0,0,1-1.442.325,2.116,2.116,0,0,1-1.381-.7,4.355,4.355,0,0,1-.62-1.532,27.819,27.819,0,0,1-.718-3.628c-.185-1.249-.505-4.43-.783-4.489s-1.358,2.208-1.616,2.691c-.505.946-.962,1.914-1.4,2.89s-.752,1.919-1.232,2.837q-.174.334-.365.659a.861.861,0,0,1-.474.463,2.111,2.111,0,0,1-.676.059c-.281,0-.561,0-.842-.025a.873.873,0,0,1-.878-.654,2.8,2.8,0,0,1,.081-1.518c.025-.123.05-.244.073-.368,0-.059.09-.247-.034-.244-.067,0-.25.224-.3.281-.1.087-.213.168-.32.25-.41.317-.814.645-1.246.931a13.031,13.031,0,0,1-2.677,1.358,7.014,7.014,0,0,1-3.03.379,5.331,5.331,0,0,1-4.209-2.848,4.944,4.944,0,0,0-.741-1.24,2.228,2.228,0,0,1-.578-1.178,1.154,1.154,0,0,1,.115-.629,2.462,2.462,0,0,0,.107-.281,1.792,1.792,0,0,0,0-.376,6.946,6.946,0,0,1,.152-1.462,7.473,7.473,0,0,1,1.08-2.464,7.6,7.6,0,0,1,1.582-1.793,5.168,5.168,0,0,1,5.2-1,3.647,3.647,0,0,1,1.731,1.939,4.052,4.052,0,0,1,.216,2.691,7.734,7.734,0,0,1-.561,1.358,5.072,5.072,0,0,1-.875,1.016,7.753,7.753,0,0,1-2.424,1.4c-.424.163-.867.281-1.279.463a2.4,2.4,0,0,0,.64.575",
    transform: "translate(237.713 -282.669)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Access_Better_Health_Wellbeing_",
    "data-name": "Access Better Health & Wellbeing ",
    transform: "translate(921 44.998)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Roboto-LightItalic, Roboto",
    fontWeight: 300,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "Access Better Health &amp; Wellbeing ")), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    transform: "translate(1005 21.998)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12983",
    "data-name": "Group 12983",
    transform: "translate(-136 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_292",
    "data-name": "Ellipse 292",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12984",
    "data-name": "Group 12984",
    transform: "translate(-136 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12985",
    "data-name": "Group 12985",
    transform: "translate(-136 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_294",
    "data-name": "Ellipse 294",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12986",
    "data-name": "Group 12986",
    transform: "translate(-136 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_295",
    "data-name": "Ellipse 295",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12987",
    "data-name": "Group 12987",
    transform: "translate(-136 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_296",
    "data-name": "Ellipse 296",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12988",
    "data-name": "Group 12988",
    transform: "translate(-136 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12989",
    "data-name": "Group 12989",
    transform: "translate(-136 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    transform: "translate(136 14)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteLogoSub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteLogoSub.985a027f.svg";
export { ForwardRef as ReactComponent };